<app-dialog-layout class="madar--v2">
  <div dialog-title>{{'sharedFeatures.CompleteInfoTitle' | translate}}</div>
  <app-state-section [state]="sectionState">
    <mat-card>
      <mat-card-content class="p-4">
        <h6 class="h6 mb-4 text-400 weight-normal">{{'sharedFeatures.CompleteInformationText' | translate}}</h6>
          <app-form   [dir]="isRtl ? 'rtl' : 'ltr'"  [fields]="fieldsGroup" [formGroup]="formGroup" [value]="patchedFormValue"></app-form>
      </mat-card-content>
    </mat-card>
  </app-state-section>
  <button dialog-action mat-dialog-close mat-stroked-button type="button" class="bg-primary-light text-primary mt-2 brd-primary-light mx-2">
    {{'shared.Buttons.Cancel' | translate}}
  </button>
  <button dialog-action type="submit" mat-flat-button color="primary" class="mt-2" (click)="saveCustomerData()">
    {{'shared.Buttons.Save' | translate}}
  </button>
</app-dialog-layout>
